// Fuentes del round-robin de tipografía para CAJA 4 del HUD (nombre del
// char + nivel + barra de exp). Vive en su propio módulo para mantener
// pages/play/index.js (~2000 líneas) más manejable.
//
// La fuente elegida se persiste en localStorage bajo
// "argentum:headerFontIndex". Index 0 = Doppio One (default).
//
// SCOPE: solo CAJA 4 del juego. El logo del navbar (ARGENTUMONLINEWEB) NO
// usa este round-robin — queda fijo en Doppio One como identidad de marca.

export const HEADER_FONTS = [
    { name: "Doppio One", family: "Doppio One" },
    { name: "Arial", family: "Arial" },
    { name: "Accia Thin", family: "AcciaPiano Thin" },
    { name: "Accia Thin Italic", family: "AcciaPiano Thin Italic" },
    { name: "Accia ExtraLight", family: "AcciaPiano ExtraLight" },
    { name: "Accia ExtraLight Italic", family: "AcciaPiano ExtraLight Italic" },
    { name: "Accia Light", family: "AcciaPiano Light" },
    { name: "Accia Light Italic", family: "AcciaPiano Light Italic" },
    { name: "Accia Regular", family: "AcciaPiano Regular" },
    { name: "Accia Italic", family: "AcciaPiano Italic" },
    { name: "Accia Medium", family: "AcciaPiano Medium" },
    { name: "Accia Medium Italic", family: "AcciaPiano Medium Italic" },
    { name: "Accia SemiBold", family: "AcciaPiano SemiBold" },
    { name: "Accia SemiBold Italic", family: "AcciaPiano SemiBold Italic" },
    { name: "Accia Bold", family: "AcciaPiano Bold" },
    { name: "Accia Bold Italic", family: "AcciaPiano Bold Italic" },
    { name: "Accia ExtraBold", family: "AcciaPiano ExtraBold" },
    { name: "Accia ExtraBold Italic", family: "AcciaPiano ExtraBold Italic" }
];

export const HEADER_FONT_STORAGE_KEY = "argentum:headerFontIndex";

// Construye el font-family string completo a partir de un índice del array.
// Siempre incluye fallback Doppio One + sans-serif por si la fuente custom
// no cargó.
export function headerFontFamilyFromIndex(index) {
    const safeIndex =
        Number.isFinite(index) && index >= 0 && index < HEADER_FONTS.length
            ? index
            : 0;
    return (
        '"' + HEADER_FONTS[safeIndex].family + '", "Doppio One", sans-serif'
    );
}

// Lee el índice persistido. Devuelve 0 si no hay nada o el valor es inválido.
export function readPersistedHeaderFontIndex() {
    if (typeof window === "undefined") return 0;
    try {
        const stored = parseInt(
            window.localStorage.getItem(HEADER_FONT_STORAGE_KEY),
            10
        );
        if (
            Number.isFinite(stored) &&
            stored >= 0 &&
            stored < HEADER_FONTS.length
        ) {
            return stored;
        }
    } catch (e) {}
    return 0;
}

